import React from 'react'
import { Box, Button } from '@mui/material'
import { useIntl } from 'react-intl'
import { CheckCircleRounded } from '@mui/icons-material'

interface Props {
    languageId: string
    selected?: boolean
    handleLanguage: (languageId: string) => void
}
const SelectLanguageCard: React.FC<Props> = ({
    selected = false,
    languageId,
    handleLanguage,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Button
            sx={{
                position: 'relative',
                border: '1px solid #EEEEEE',
                borderColor: selected ? 'primary.main' : '#EEEEEE',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 1,
                mr: 4,
                mb: 2,
                width: '200px',
                height: '70px',
                cursor: 'pointer',
            }}
            onClick={() => handleLanguage(languageId)}
        >
            {selected && (
                <Box
                    sx={{
                        borderRadius: '4px',
                        position: 'absolute',
                        top: '-15px',
                        left: '-15px',
                        background: '#fff',
                        height: 30,
                        width: 30,
                    }}
                >
                    <CheckCircleRounded
                        color="primary"
                        sx={{ mr: 1, height: 30, width: 30 }}
                    />
                </Box>
            )}
            <Box sx={{ color: selected ? 'inherit' : 'black' }}>
                {formatMessage({ id: languageId })}
            </Box>
        </Button>
    )
}
export default SelectLanguageCard
